import React from "react";
import { Layout as AntLayout } from "antd";
import { Header } from "../../components/Header";
import { Outlet } from "react-router-dom";

const { Content } = AntLayout;

const Layout: React.FC = () => {
  return (
    <AntLayout
      className="layout"
      style={{
        minHeight: "100vh",
      }}
    >
      <Header />
      <Content
        style={{
          marginTop: "48px",
          width: "100%",
        }}
      >
        <div
          style={{
            width: "calc(100% - 48px)",
            margin: "0 auto",
            paddingBottom: "1rem",
          }}
        >
          <Outlet />
        </div>
      </Content>
    </AntLayout>
  );
};

export { Layout };
